import type { SetNodeType } from '@/nodes/types';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';

const SetNode: FC<NodeProps<SetNodeType>> = ({ id, data }) => {
    const paths = outgoingHandles.set(id as GuideNodeId, data);
    return (
        <div className="border-1 rounded-lg m-1 px-3 py-2 bg-purple-50 border-purple-300">
            <div className="flex flex-col items-center justify-center ">
                <div className="text-sm font-bold text-purple-900">SET</div>
                <div className="text-[6pt] text-purple-900">
                    {data.field} = {data.value}
                </div>
            </div>

            <Handle type="target" position={Position.Left} />
            <Handle type="source" id={paths.next} position={Position.Right} />
        </div>
    );
};

export default SetNode;
